import { render, staticRenderFns } from "./faq-widget.vue?vue&type=template&id=2bd7ac76"
import script from "./faq-widget.vue?vue&type=script&lang=ts"
export * from "./faq-widget.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports